import { render, staticRenderFns } from "./ShiftPalletList.vue?vue&type=template&id=716712aa&"
import script from "./ShiftPalletList.vue?vue&type=script&lang=ts&"
export * from "./ShiftPalletList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports